// @react
import React, { useState, ReactElement } from 'react'
// @components
import { PropsType as SearchPanelProps } from '__COMPONENTS_TO_MIGRATE/SearchPanel'
// @module components
import Top from './Top'
import Bottom from './Bottom'
import useBodyScrollLock from 'modules/common/hooks/useBodyScrollLock'

type PropsType = {
  /** Search Panel props */
  searchPanelProps: SearchPanelProps
}

const DesktopMenu = ({ searchPanelProps }: PropsType): ReactElement => {
  /********************************
   * STATE
   ********************************/

  const [showMegaMenu, setShowMegaMenu] = useState(false)
  useBodyScrollLock(showMegaMenu)
  /********************************
   * RENDER
   ********************************/
  return (
    <React.Fragment>
      {/* Main Links */}
      <Top
        condensedMenu={
          <Bottom
            asCondensedMenu
            toggleMegaMenu={() => {
              setShowMegaMenu(!showMegaMenu)
            }}
            showMegaMenu={showMegaMenu}
          />
        }
        searchPanelProps={searchPanelProps}
      />

      {/* Bottom Links */}
      <Bottom
        toggleMegaMenu={() => {
          setShowMegaMenu(!showMegaMenu)
        }}
        showMegaMenu={showMegaMenu}
      />
    </React.Fragment>
  )
}

export default DesktopMenu
